import { render } from "./AnatAten.vue?vue&type=template&id=5d6c6a84&scoped=true"
import script from "./AnatAten.vue?vue&type=script&lang=js"
export * from "./AnatAten.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=5d6c6a84&scoped=true&lang=css"
import "@/assets/css/tabla_estilizada.css?vue&type=style&index=1&id=5d6c6a84&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=2&id=5d6c6a84&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=3&id=5d6c6a84&scoped=true&lang=css"
import "./AnatAten.vue?vue&type=style&index=4&id=5d6c6a84&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6c6a84"]])

export default __exports__